// Every value is the shipping gateway's own spelling and must match it byte for byte: the tracking
// webhook stores 'In Transit' and 'Delivered'
// (libs/logistic/node/src/actions/shipping/LogisticShipEngineWebhookHandler.ts:25,29), and a label
// purchase copies the gateway's own label status verbatim
// (libs/shipping/node/src/gateway/shipengine/ShipEngineShippingGateway.ts:275). The keys therefore
// diverge from the values on purpose, and no value may ever be re-cased. Deliberately never
// registered as a GraphQL enum and never referenced by a field, argument or Mongo schema — the
// stored shipment status stays a free-form string, so this closes only the key set of the status
// map that paints it, where a missing entry becomes a compile error.
export enum ShipmentStatusEnum {
  Delivered = 'Delivered',
  InTransit = 'In Transit',
  Processing = 'processing',
  Completed = 'completed',
  Error = 'error',
  Voided = 'voided',
}
